// extracted by mini-css-extract-plugin
export default {"otpDiv":"otp_otpDiv__Xx0GW","OtpInput":"otp_OtpInput__58hCA","terms":"otp_terms__FxiXw","otpField":"otp_otpField__C7Czu","visitorSystem":"otp_visitorSystem__5uMuD"};